import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {FiX} from "react-icons/fi";
import {components, MultiValueRemoveProps} from "react-select";

export const MultiValueRemove = <I,>(props: MultiValueRemoveProps<I>) => {
  if (props.selectProps.isDisabled) {
    return null;
  }
  return (
    <components.MultiValueRemove {...props}>
      <IconButton icon={FiX} variant="ghost" size="fitIcon" />
    </components.MultiValueRemove>
  );
};
